import { fetcher } from '@/config/api';

export interface GenerateImageParams {
  prompt: string;
  style?: 'natural' | 'vivid';
  quality?: 'standard' | 'hd';
  size?: '1024x1024' | '1024x1792' | '1792x1024';
}

export interface GenerateImageResponse {
  success: boolean;
  url?: string;
  error?: string;
  created?: number;
}

/**
 * Generate an image based on the given prompt and parameters
 */
export const generateImage = async (params: GenerateImageParams): Promise<GenerateImageResponse> => {
  try {
    return await fetcher<GenerateImageResponse>('/api/images/generate', {
      method: 'POST',
      body: JSON.stringify(params),
    });
  } catch (error) {
    console.error('Error generating image:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : String(error),
    };
  }
};

export interface ImageMetadata {
  id: string;
  prompt: string;
  url: string;
  local_path?: string;
  created_date: string;
  style: string;
  quality: string;
  size: string;
}

/**
 * Fetch user's image generation history
 */
export const getImageHistory = async (limit: number = 20): Promise<ImageMetadata[]> => {
  try {
    return await fetcher<ImageMetadata[]>(`/api/images/history?limit=${limit}`);
  } catch (error) {
    console.error('Error fetching image history:', error);
    return [];
  }
};
